export default __webpack_public_path__ + "static/media/abs.969d68a7.png";